/**
 * Application configuration declaration.
 *
 * This configuration file is shared between the website and the build script so
 * that values don't have to be duplicated across environments. Any non-shared,
 * environment-specific configuration should placed in appropriate configuration files.
 */
require.config({
    baseUrl: '/mydtn-public-core-portlet/assets/scripts',

    // This is just to set a shorter alias for longer paths
    paths: {
        // Path shortcuts
        'shared-scripts': './',  // Path to shared js between free/ premium
        'jquery-ui': 'lib-thirdparty/jquery-ui', // just a path shorthand, use as: require('jquery-ui/datepicker')

        // Third party libraries
        'jquery': 'lib-thirdparty/jquery-2.1.4.min',
        'knockout': 'lib-thirdparty/knockout-2.2.1',
        'Handlebars': 'lib-thirdparty/Handlebars.async.min',
        'mout': 'lib-thirdparty/mout',
        'slip': 'lib-thirdparty/slip',
        'touch-input-nav': 'lib-thirdparty/touch-input-nav.min',
        'moment': 'lib-thirdparty/moment-2.1.0.min',
        'hammer': 'lib-thirdparty/hammer-2.0.1.min',
        'highcharts': 'lib-thirdparty/highcharts.min',
        'eq': 'lib-thirdparty/eq.min',

        // Plugins
        'truncate': 'lib-thirdparty/truncate',
        'text': 'lib-thirdparty/text.async',
        'transit': 'lib-thirdparty/jquery.transit.modified',
        'aths': 'lib-thirdparty/addtohomescreen-3.1.1',
        'pointer': 'lib-thirdparty/jquery.pointer',

        // Polyfills
        'es6-promise': 'lib-thirdparty/es6-promise.min',
        'es6-polyfills': 'lib-thirdparty/es6-polyfills',
    },

    // This allows us to set dependencies for third-party libraries that do not follow the RequireJS pattern
    shim: {
        'jquery': { exports: '$' },
        'pointer': { deps: ['jquery'] },
        'lib-thirdparty/jquery.cookie': { deps: ['jquery'] },
        'truncate': { deps: ['jquery']},
        'transit': { deps: ['jquery']},
        'slip': { exports: 'slip' },
        'highcharts': { exports: 'Highcharts' },
        'aths': { exports: 'addToHomescreen' },
    },
});
